const fsrsetCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const fsrgetCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie 
  try{
  decodedCookie = decodeURIComponent(document.cookie);
  }catch(e){
    return ""
  }
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

window.addEventListener('load', () => {
  let ort_cookie = fsrgetCookie('standort')
  console.log('Ort-Cookie:'+ ort_cookie)
  
  if(ort_cookie){
    let links = [
      document.querySelectorAll('[data-link="Dachbox inkl. Träger"]'),
      document.querySelectorAll('[data-link="Dachbox"]'),
      document.querySelectorAll('[data-link="Dachträger"]'),
      document.querySelectorAll('[data-childlink="xt2"]'),
      document.querySelectorAll('[data-childlink="xt3"]'),
      document.querySelectorAll('[data-childlink="proride"]'),
      document.querySelectorAll('[data-link="SnowPack"]')
    ]
links.forEach((link)=>{
      link.forEach((a)=>{
        let link = a.dataset.link ?? a.dataset.childlink
        switch (link){
          case ("Dachbox inkl. Träger"):
            a.href = '/products/thule-dachbox-inkl-traeger-l-'+ort_cookie
            break
          case ("Dachbox"):
            a.href = '/products/thule-dachbox-l-'+ort_cookie
            break
          case ("Dachträger"):
            a.href = '/products/thule-wingbar-evo-'+ort_cookie 
            break
          case ("xt2"):
            a.href = '/products/thule-easyfold-xt-2-'+ort_cookie 
            break
          case ("xt3"):
            a.href = '/products/thule-easyfold-xt-3-'+ort_cookie 
            break
          case ("proride"):
            a.href = '/products/thule-proride-'+ort_cookie 
            break
          case ("SnowPack"):
            a.href = '/products/thule-snowpack-inkl-traeger-l-'+ort_cookie 
            break
        }
      })      
    })
  }
})
